import {
  CurrencyDisplay,
  CurrencyFormat,
  DEFAULT_CURRENCY_DISPLAY,
  DEFAULT_CURRENCY_FORMAT,
} from '@domain/currency-preferences';

import { currencyPreferences, numberFormatCache } from './constants';

export const setCurrencyPreferences = (format?: CurrencyFormat, display?: CurrencyDisplay, lang?: string): void => {
  currencyPreferences.format = format ?? DEFAULT_CURRENCY_FORMAT;
  currencyPreferences.display = display ?? DEFAULT_CURRENCY_DISPLAY;
  currencyPreferences.lang = lang ?? 'en';
  numberFormatCache.clear();
};
